export default class NotImplementedException {
  constructor(message) {
    this.message = message;
  }
}
